<template>
  <div>
    <template v-if="!isLoading && !themes.length">
      <add-first-site />
    </template>

    <c-row v-show="isLoading">
      <c-col sm="12">
        <p class="lead">
          Getting themes...
          <c-spinner color="success" size="sm" />
        </p>
      </c-col>
    </c-row>

    <template v-if="!isLoading && themes.length">
      <c-row>
        <c-col sm="12">
          <c-tabs>
            <c-tab title="Themes" active>
              <template slot="title">
                <c-icon :content="freeSet.cilPaint" />
                Themes
                <pill :value="themes.length" width="40px" />
              </template>
              <theme-list :themes="themes" :view-type-default="'grid'"></theme-list>
            </c-tab>
          </c-tabs>
        </c-col>
      </c-row>
    </template>
  </div>
</template>

<script>
import { freeSet } from '@coreui/icons';
import { buildEndpoint } from '@/libs/buildEndPoint';
import Pill from '../components/Pill';
import ThemeList from '../components/theme-list';
import AddFirstSite from '@/views/components/dashboard/AddFirstSite';

export default {
  name: 'Plugins',

  components: {
    Pill,
    ThemeList,
    AddFirstSite,
  },

  data() {
    return {
      freeSet,
      isLoading: true,
      themes: [],
      sitesViewType: 'grid',
      numberOfPluginsRequiringUpdates: 0,
      numberOfPlugins: 0,
      error: null,
    };
  },

  computed: {},

  created() {
    this.get();
  },

  methods: {
    get() {
      this.$http
        .get(buildEndpoint('theme/organisation'))
        .then((response) => {
          this.error = null;
          if (response.data.success) {
            this.themes = response.data.data;
          } else {
            this.error = 'Error getting themes';
          }
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.error = error;
        });
    },
  },
};
</script>

<style lang="scss" scoped="">
ol {
  margin-left: 30px;
}

.plugin-list {
  thead {
    tr {
      th {
        &:first-child {
          width: 40%;
        }
      }
    }
  }
}
</style>
